/**
 * TreesPanel - Inventario de árboles del proyecto
 *
 * @version 2.0
 * @updated 2026-02-27
 * @module core/layouts/panels/LeftPanel
 *
 * @description
 * Panel de inventario de árboles configurado con BaseInventoryPanel.
 * Todas las funcionalidades (paginación, sorting, multi-select, etc.)
 * están implementadas en el componente base.
 *
 * @remarks
 * Migrado desde implementación custom (876 líneas) a configuración (5 líneas).
 * Mantiene exactamente el mismo comportamiento y UX.
 */

import { BaseInventoryPanel } from './BaseInventoryPanel';
import { treesInventoryConfig } from '../../../modules/environmental/config/trees-inventory.config';

/**
 * Panel de inventario de árboles.
 * Wrapper del BaseInventoryPanel configurado para árboles.
 */
export function TreesPanel(): JSX.Element {
  return <BaseInventoryPanel config={treesInventoryConfig} />;
}
